import { AssetData, LinkData, MenuItemData } from "./schemas";

export const resolveLink = (link: LinkData) => {
  return link.linktype == "url"
    ? link.url
    : storyblokSlugToUrl(link.cached_url);
};

export const resolveMenuItemAttributes = (item: MenuItemData) => ({
  href: !!item.anchor
    ? `#${item.anchor}`
    : !!item.link
    ? resolveLink(item.link)
    : "",
  target: !!item.anchor ? "" : item.link?.target,
});

const storyblokSlugToUrl = (slug: string) => {
  if (slug.startsWith("landingspages/")) {
    if (process.env.NEXT_PUBLIC_USE_SUBDOMAINS === "yes") {
      const [_, subdomain, ...pathComponents] = slug.split("/");
      const path = pathComponents.join("/");
      return `https://${subdomain}.${process.env.NEXT_PUBLIC_DOMAIN}/${path}`;
    } else {
      return `https://${process.env.NEXT_PUBLIC_DOMAIN}/${slug.replace(
        "landingspages/",
        ""
      )}`;
    }
  }

  return slug;
};

export const resolveImageUrl = (
  asset: AssetData,
  { width = 0, height = 0 }: { width?: number; height?: number } = {}
) => {
  if (asset.is_external_url || asset.filename.endsWith(".svg")) {
    return asset.filename;
  }

  if (width === 0 && height === 0) {
    return `${asset.filename}/m/`;
  }

  return `${asset.filename}/m/${width.toFixed(0)}x${height.toFixed(0)}`;
};

export const resolveSectionClasses = (
  { section_width }: { section_width?: string },
  baseClasses: string = ""
) => `${baseClasses} container-size-${section_width || "m"}`;
